import { formatDate } from '../../../utils/format';
export const displayValue = value => {
  if (value === null || value === undefined || value === '') return '-';
  return value;
};

export const formatSubmittedDate = formatDate;

export const getHpsStatusKind = status => {
  if (status === true) return 'available';
  if (
    status === false ||
    status === null ||
    status === undefined ||
    status === ''
  ) {
    return 'not-available';
  }

  if (typeof status === 'string') {
    const label = status.trim().toLowerCase();
    if (label === 'available' || label === '1' || label === 'true') {
      return 'available';
    }
    if (label === 'revise' || label === '2') return 'revise';
    return 'not-available';
  }

  if (Number(status) === 1) return 'available';
  if (Number(status) === 2) return 'revise';
  return 'not-available';
};

export const isHpsNotAvailable = status =>
  getHpsStatusKind(status) === 'not-available';

export const isHpsRevise = status => getHpsStatusKind(status) === 'revise';

export const canEditHpsAlpha = status => {
  const kind = getHpsStatusKind(status);
  return kind === 'not-available' || kind === 'revise';
};

export const getProcurementStatusConfig = status => {
  const kind = getHpsStatusKind(status);

  if (kind === 'available') {
    return {
      label: 'Available',
      tone: 'success',
      className: 'bg-success text-light',
    };
  }

  if (kind === 'revise') {
    return {
      label: 'Revise',
      tone: 'warning',
      className: 'bg-warning text-dark',
    };
  }

  return {
    label: 'Not Available',
    tone: 'warning',
    className: 'bg-info text-light',
  };
};

// Hanya izinkan skema http/https sebelum URL dari API dibuka via window.open.
export const isSafeExternalUrl = url => {
  if (typeof url !== 'string' || !url.trim()) return false;
  try {
    const parsed = new URL(url, window.location.origin);
    return parsed.protocol === 'http:' || parsed.protocol === 'https:';
  } catch {
    return false;
  }
};
